import styles from './SideRailPromos.module.css';
import { env  } from '../../../../../env';

const title1 = 'Specific HR Issues?';
const text1 = 'Need help with a specific HR issue like coronavirus or FLSA?';
const action1 = 'ASK AN ADVISOR';
const title2 = 'Other Questions?';
const text2 = 'Reach out to us for account, product and service-related help.';
const action2 = 'Contact Us';

const SideRailPromos = () => {
  return (
    <div className={styles.container}>
      <div className={styles.box}>
        <div className={styles.title}>{title1}</div>
        <div className={styles.text}>{text1}</div>
        <div className={styles.link}>
          <a href={env.REACT_APP_ASK_AN_ADVISOR} target='_blank'>{action1}</a>
        </div>
      </div>

      <div className={styles.box}>
        <div className={styles.title}>{title2}</div>
        <div className={styles.text}>{text2}</div>
        <div className={styles.link}>
          <a href={env.REACT_APP_CONTACT_US_URL} target='_blank'>{action2}</a>
        </div>
      </div>
    </div>
  );
};

export default SideRailPromos;
